import { useAppNavigation } from '../../../hooks/useAppNavigation';

import { MealPlanner } from './MealPlanner';

import { AdaptiveModal } from '../../modal/AdaptiveModal';

export const MealPlannerModal = () => {
  const { showMealPlannerModal, setShowMealPlannerModal } = useAppNavigation();

  return (
    <AdaptiveModal
      open={showMealPlannerModal}
      onOpen={setShowMealPlannerModal}
      background="background-secondary"
      contentStyle={{ minWidth: '420px', width: '700px', maxWidth: '96vw', height: '85vh' }}
    >
      <MealPlanner />
    </AdaptiveModal>
  );
};
